import { Plus, Trash2 } from "lucide-react";

export const JTanks = ({ tanks, tank, update, select, add, remove, planWeek }) => {
  const del = () => {
    if (window.confirm(`¿Borrar «${tank.name || "este depósito"}»?`)) remove();
  };
  return (
    <div data-testid="tanks" className="mt-6">
      <span className="text-xs text-[#C9D6C2]">Mis depósitos</span>
      <div data-lenis-prevent className="mt-1 flex gap-2 overflow-x-auto pb-1" data-testid="tank-list">
        {tanks.map((t, i) => (
          <button key={t.id} type="button" onClick={() => select(t.id)} data-testid={`tank-chip-${i}`} aria-pressed={t.id === tank.id}
            className={`shrink-0 h-10 px-4 rounded-full border text-sm transition-[background-color,border-color,color] ${t.id === tank.id ? "bg-[#F2B441] text-[#0E2A1C] border-[#F2B441] font-semibold" : "border-[#F6EEDC]/25 text-[#F6EEDC] hover:border-[#F2B441]"}`}>
            {t.name || "Sin nombre"} <span className="font-mono-d text-xs opacity-80">· {t.liters || 0} L · {t.week ?? planWeek}</span>
          </button>
        ))}
        <button type="button" onClick={add} data-testid="tank-add" className="shrink-0 h-10 px-4 rounded-full border border-dashed border-[#B9E79A]/60 text-[#B9E79A] text-sm inline-flex items-center gap-1.5 hover:bg-[#B9E79A]/10 transition-colors">
          <Plus className="w-4 h-4" aria-hidden /> Nuevo
        </button>
      </div>
      <div className="mt-3 flex gap-2">
        <label className="flex-1">
          <span className="sr-only">Nombre del depósito</span>
          <input data-testid="tank-name-input" value={tank.name} maxLength={30} onChange={(e) => update({ name: e.target.value })} placeholder="Nombre, p. ej. Armario 1"
            className="w-full h-11 rounded-[6px] bg-[#143823] border border-[#F6EEDC]/25 px-3 text-[#F6EEDC] focus:border-[#F2B441] outline-none" />
        </label>
        {tanks.length > 1 && (
          <button type="button" onClick={del} data-testid="tank-delete" aria-label="Borrar depósito" className="w-11 h-11 rounded-[6px] border border-[#F6EEDC]/25 grid place-items-center text-[#F6EEDC] hover:border-[#E5765B] hover:text-[#E5765B] transition-colors">
            <Trash2 className="w-4 h-4" />
          </button>
        )}
      </div>
    </div>
  );
};
